import { Icon } from "@jobber/components/Icon";
import { Text } from "@jobber/components/Text";
import styles from "./Footer.module.scss";

const HELP_URL =
  "https://help.getjobber.com/hc/en-us/articles/34516153918103-Jobber-and-The-Home-Depot-Integration";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <Icon name="help" color="heading" />
      <Text>
        <a href={HELP_URL} target="_blank" rel="noopener noreferrer">
          Need help?
        </a>
      </Text>
    </div>
  );
};

export default Footer;
